import axiosInstance from 'api/axiosInstance';
import { format } from 'date-fns';

export async function getScheduledItems(
	customContact: number | null,
	customDate: Date | null,
): Promise<any[]> {
	let url = '/Project/WebService/CANDispatch.asmx/GetScheduledItems';

	if (process.env.NODE_ENV === 'production') {
		url = '/Portal' + url;
	}

	if (customContact && customDate) {
		// when both customContact and customDate are provided, append 'Legacy' to the url
		// this is because getScheduledItems & getScheduledItemsLegacy perform some different filtering
		// in the future, we should refactor this to use a single endpoint
		url += 'Legacy';
	}

	const { data } = await axiosInstance({
		method: 'POST',
		url: url,
		data: {
			customContact: customContact?.toString() || '',
			customDate: customDate
				? format(
						customDate.setHours(6, 0, 0, 0),
						'yyyy/MM/dd HH:mm:ss.SSS',
				  )
				: '',
		},
	});

	return JSON.parse(data.d);
}
